import React from "react";

// import {TransactionContext} from "../../../../../context";
// import {CustomBadges, TableLoading, TableNullData} from "../../../../../components";

import "./index.scss";
import {
  CustomBadges,
  CustomButton2,
  CustomIcon,
  CustomModal,
  TableNullData,
  UserInformation,
} from "../../../../../../components";
import utils from "../../../../../../utils";
import {
  GATEWAY,
  PAYER_TYPE,
  PAY_TYPE,
  TRANSACTION_REASON,
} from "../../../../../../values/dropdownItems";
import Context from "../../../../../../context";
import { useTranslation } from "react-i18next";

type Props = {
  data: any;
};

const Body = ({ data }: Props) => {
  console.log(data);
  const { requestDebt, setShowModal, showModal, setSelectedDebt } =
    React.useContext(Context.DebtScreen);
  const [openInfoModal, setOpenInfoModal] = React.useState<boolean>(false);
  const docs = data?.data?.result;

  function onClickInfo() {
    setOpenInfoModal(!openInfoModal);
  }

  function onClickRow(index: number) {
    // setSelectedUserId(index);
    // setShowModal("SHOW");
  }

  const showInfoHandler = (debt: any) => {
    setSelectedDebt(debt);
    setShowModal("SHOW_DEBT_USER_INFO");
  };
  const payDebtHandler = (debt: any) => {
    setSelectedDebt(debt);
    setShowModal("PAY_DEBT");
  };

  const { t } = useTranslation();

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <>
      <tbody id="find-transaction-body-container">
        {docs?.map((debt: any, index: number) => {
          let payerInfo: any = {};

          payerInfo = debt?.payerId;

          return (
            <tr
              key={`files-tr-${index}`}
              onClick={() => onClickRow(debt?.debtId?._id)}
            >
              <td onClick={onClickInfo}>
                <div className="table-index-number">
                  {requestDebt.page === 1
                    ? index + 1
                    : (requestDebt.page - 1) * 10 + index + 1}
                </div>
              </td>
              <td onClick={onClickInfo} className="table-text">
                {debt?.name}
              </td>{" "}
              <td onClick={onClickInfo} className="table-text">
                {debt?.studentName}
              </td>{" "}
              <td onClick={onClickInfo} className="table-text">
                {debt?.driverPhoneNumber}
              </td>
              <td onClick={onClickInfo} className="table-text">
                {utils.convertNumberToPrice(debt.totalAmount)}
                {t(" toman")}
              </td>{" "}
              <td onClick={onClickInfo} className="table-text">
                {debt.count}
              </td>
              <td onClick={onClickInfo} className="table-text">
                <div className="table-actions-buttons">
                  <CustomButton2
                    title={t("view")}
                    type="info"
                    onClick={() => showInfoHandler(debt)}
                  />
                  <CustomButton2
                    title={t("payed")}
                    type="primary"
                    onClick={() => payDebtHandler(debt)}
                  />
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );
};

export default Body;
